import React from 'react';
import { ContextValue } from './types';

export const BrazeContext = React.createContext<ContextValue>({
  contentCards: [],
  contentCardLogImpression: () => {},
  contentCardLogClick: () => {},
  isBrazeInitialized: false,
  inAppMessages: [],
  inAppMessageClick: () => {},
  removeMessage: () => {},
});
